var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollaborativeWhiteboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 5.75C0.75 4.64543 1.64543 3.75 2.75 3.75H21.25C22.3546 3.75 23.25 4.64543 23.25 5.75V19.75C23.25 20.8546 22.3546 21.75 21.25 21.75H2.75C1.64543 21.75 0.75 20.8546 0.75 19.75V5.75Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 16.0227L5.15054 13.4763C5.88963 12.1325 7.83403 12.1724 8.51728 13.5455L8.61931 13.7505C9.1643 14.8457 10.6384 15.0536 11.465 14.1518V14.1518C12.1559 13.3981 13.3441 13.3981 14.035 14.1518L14.1027 14.2257C14.9275 15.1255 16.3847 14.9842 17.0212 13.9426L20.25 8.65909",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaborativeWhiteboard);
export default __webpack_public_path__ + "static/media/collaborative-whiteboard.78916c4ed1f0596672f0da8e5642bdfb.svg";
export { ForwardRef as ReactComponent };